import React from 'react';
import PropTypes from 'prop-types';

import VerticalSpacer from 'dashboard/components/VerticalSpacer';
import FormRow from 'dashboard/components/form/FormRow';
import FormField from 'dashboard/components/form/FormField';
import TextField from 'dashboard/components/form/TextField';
import { getFormikErrorProps } from 'shared/helpers/errors';
import { Button, Heading, Spacer } from 'school-space-client/components';

const css = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh'
    },
    contentWrapper: {
        flexGrow: '1'
    },
    button: theme => ({
        maxWidth: theme.layout.baseline * 16
    }),
    header: {
        textAlign: 'center'
    }
};

const VerifyCustomer = ({
    addressLine1,
    addressLine2,
    townCity,
    postCode,
    country,
    errors,
    touched,
    submit,
    setFieldValue
}) => (
    <form>
        <Heading level="3" size="x-large" styles={css.header}>
            Welcome to School Space!{' '}
        </Heading>
        <Spacer height={0.5} />
        <Heading level="3" size="x-small" styles={css.header}>
            Please confirm your details{' '}
        </Heading>
        <FormRow alignCenter>
            {' '}
            <FormField inline width={425}>
                <TextField
                    id="customer-address-line1"
                    name="Address Line 1"
                    value={addressLine1}
                    setValue={value => setFieldValue('addressLine1', value)}
                    placeholder="5-7 Buck Street"
                    required
                    {...getFormikErrorProps('addressLine1', errors, touched)}
                />
            </FormField>
        </FormRow>
        <FormRow alignCenter>
            {' '}
            <FormField inline width={425}>
                <TextField
                    id="customer-address-line2"
                    name="Address Line 2"
                    value={addressLine2}
                    setValue={value => setFieldValue('addressLine2', value)}
                    placeholder="Camden Town"
                    {...getFormikErrorProps('addressLine2', errors, touched)}
                />
            </FormField>
        </FormRow>
        <FormRow alignCenter>
            {' '}
            <FormField inline width={425}>
                <TextField
                    id="customer-town-city"
                    name="Town/City"
                    value={townCity}
                    setValue={value => setFieldValue('townCity', value)}
                    placeholder="London"
                    {...getFormikErrorProps('townCity', errors, touched)}
                />
            </FormField>
        </FormRow>
        <FormRow alignCenter>
            {' '}
            <FormField inline width={425}>
                <TextField
                    id="customer-post-code"
                    name="Postcode"
                    value={postCode}
                    setValue={value => setFieldValue('postCode', value)}
                    placeholder="NW1 8NJ"
                    required
                    {...getFormikErrorProps('postCode', errors, touched)}
                />
            </FormField>
        </FormRow>
        <FormRow alignCenter>
            {' '}
            <FormField inline width={425}>
                <TextField
                    id="customer-country"
                    name="Country"
                    value={country}
                    setValue={value => setFieldValue('country', value)}
                    placeholder="United Kingdom"
                    required
                    {...getFormikErrorProps('country', errors, touched)}
                />
            </FormField>
        </FormRow>
        <VerticalSpacer />
        <FormRow alignCenter>
            <Button styles={css.button} state="primary" onClick={submit} disabled={false}>
                Confirm
            </Button>
        </FormRow>
    </form>
);

VerifyCustomer.defaultProps = {
    addressLine1: null,
    addressLine2: null,
    townCity: null,
    postCode: null,
    country: null
};

VerifyCustomer.propTypes = {
    addressLine1: PropTypes.string,
    addressLine2: PropTypes.string,
    townCity: PropTypes.string,
    postCode: PropTypes.string,
    country: PropTypes.string,
    errors: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)).isRequired,
    touched: PropTypes.objectOf(PropTypes.bool).isRequired,
    submit: PropTypes.func.isRequired,
    setFieldValue: PropTypes.func.isRequired
};

export default VerifyCustomer;
